import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "app/redux-store-interactions";
import { featuresConfig, WidgetKey } from "config/features";
import { useOpenWidget } from "hooks/useOpenWidget";
import { selectEnabledWidgetKeys, selectWidgets } from "slices/explorer";

export function WidgetMenuItem({ feature, onSelect }: { feature: WidgetKey; onSelect?: () => void }) {
    const { t } = useTranslation();
    const isEnabled = useAppSelector((state) => selectEnabledWidgetKeys(state).has(feature));
    const isActive = useAppSelector((state) => selectWidgets(state).includes(feature));
    const openWidget = useOpenWidget();

    if (!isEnabled) {
        return null;
    }

    const config = featuresConfig[feature];
    const Icon = config.Icon;

    const handleClick = () => {
        onSelect?.();
        openWidget(feature);
    };

    return (
        <MenuItem onClick={handleClick} disabled={isActive}>
            <ListItemIcon>
                <Icon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t(config.nameKey)}</ListItemText>
        </MenuItem>
    );
}
